<header class="sub-page-layout__header admissionType__header">
  <div class="admissionType__header-text h2 h2--semi-bold">Admission Types</div>
  <mat-slide-toggle
    class="admissionType__active-toggle"
    [checked]="activeFilter === 'active'"
    color="primary"
    (change)="showInactiveChanges($event)"
  >
    <div *ngIf="activeFilter !== 'inactive'">Active</div>
    <div *ngIf="activeFilter === 'inactive'">Inactive</div>
  </mat-slide-toggle>
  <button mat-flat-button color="primary" class="admissionType__add-item" (click)="uploadCodes()" *ngIf="!viewOnly">
    <mat-icon>file_upload</mat-icon> Upload Admission Types
  </button>
  <button
    mat-flat-button
    color="primary"
    class="admissionType__add-item"
    (click)="addAdmissionType()"
    *ngIf="!viewOnly"
  >
    <mat-icon>add_circle_outline</mat-icon> Add Admission Type
  </button>
</header>
<div *ngIf="dataSource && gridConfig" class="lib-grid__grid-container">
  <lib-grid [dataSource]="dataSource" [gridConfiguration]="gridConfig" skipLoadOnInit="true" loadAfterInit="true">
    <div class="">
      <h4>No Admission Types Found.</h4>
    </div>
  </lib-grid>
</div>
<footer *ngIf="isImplementation" class="admissionType__footer">
  <lib-button-loading color="primary" class="admissionType__button" (clickEvent)="next()" id="nextButton"
    >Next
  </lib-button-loading>
</footer>
